const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');
const GraphQLForm = require('app/graphql/Form');
const ListTable = require('app/ui/list/Table');
const ConfirmModal = require('app/ui/modal/Confirm');
const Modal = require('app/ui/Modal');
const IFrame = require('app/ui/modal/IFrame');

const CreateModal = require('app/seller/CreateModal');

class ListView {
    defaultOptions() {
        return {
            'selector': '.view-seller-list',
            'tableContainerSelector': '.seller-list-container',

            'sellerShowBaseUrl': window.App.get('sellerShowBaseUrl'),
            'sellerStatsBaseUrl': window.App.get('sellerStatsBaseUrl'),
            'sellerRestaurantsBaseUrl': window.App.get('sellerRestaurantsBaseUrl'),
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = $(this.settings.selector);
        if (this.$container.length <= 0) {
            window.notify("Can't find container view with selector " + this.settings.selector, 'danger');
        }

        this.onClickCreate = this.onClickCreate.bind(this);

        this.$tableContainer = $(this.settings.tableContainerSelector, this.$container);
        this.$filterForm = $(this.settings.filterFormSelector, this.$container);
        this.$sendOrder = $(this.settings.sendOrderSelector);
        this.$sendOrderFormSelector = $(this.settings.sendOrderFormSelector);

        this.$btnCreate = $('.btn-seller-create');

        this.initialize();
    }

    initialize() {
        this.initializeListTable();
        this.initializeOldStatsClick();
        this.bindEvents();
    }

    refresh() {
        this.table.refresh();
    }

    initializeListTable() {
        var self = this;

        let fields = [
            'id',
            'phone',
            'user { createdAt firstName lastName email }'
        ];

        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped order-list',
            'id': 'list-sellers',
            'length': 50,
            'graphQL': {
                'queryType': 'sellers',
                'fields': fields,
                'parameters': {
                    'filter': {
                        'marginDisabled': false
                    },
                    'orderBy': 'lastName'
                },
            },
            'columns': [
                {
                    'name': 'createdAt',
                    'label': window.translate('restaurant.order.createdAt.label'),
                    'class': 'seller-date',
                    'ordered': true,
                    'orderType': 'createdAt',
                    'orderDir': 'DESC',
                    'render': function (item, index) {
                        return window.formatDate(item.node.user.createdAt, window.translate('momentDateFormat.fullDay'));
                    },
                },
                {
                    'name': 'name',
                    'label': 'Nom',
                    'class': 'seller-name',
                    'render': function (item, index) {
                        return item.node.user.firstName + ' ' + item.node.user.lastName;
                    },
                },
                {
                    'name': 'email',
                    'label': 'Email',
                    'class': 'seller-email',
                    'render': function (item, index) {
                        return '<a href="mailto:' + item.node.user.email + '">' + item.node.user.email + '</a>';
                    },
                },
                {
                    'name': 'phone',
                    'label': 'Téléphone',
                    'class': 'seller-phone',
                    'render': function (item, index) {
                        return item.node.phone;
                    },
                },
                {
                    'name': 'actions',
                    'label': '',
                    'class': 'order-actions',
                    'render': function (item, index) {
                        let $list = $('<ul/>')
                            .addClass('list-inline btn-list-inline');

                        let btns = [];

                        // Accès à son espace
                        let $btnShow = $('<a/>')
                            .attr('href', window.App.get('oldAdminBaseUrl') + "/commerciaux/admin-access/" + item.node.id)
                            .addClass('btn btn-link')
                            .attr('target', '_blank')
                            .attr('title', 'Voir')
                            .append(
                                $('<i/>')
                                    .addClass('fa fa-search')
                            );
                        btns.push($btnShow);

                        // Edit informations (comme ajout)
                        let urlEdit = self.settings.sellerShowBaseUrl.replace('__ID__', item.node.id);
                        let $btnEdit = $('<a/>')
                            .attr('href', urlEdit)
                            .addClass('btn btn-link')
                            .attr('title', 'Editer les informations')
                            .append(
                                $('<i/>')
                                    .addClass('fa fa-pencil')
                            );
                        btns.push($btnEdit);

                        // Stats
                        //let urlStats = self.settings.sellerStatsBaseUrl.replace('__ID__',item.node.id);
                        //let urlStats = window.App.get('oldAdminHomeUrl') + '/sellers/stats/simple&id=' + item.node.id;
                        let $btnStats = $('<a/>')
                            .attr('href', '#stats')
                            .addClass('btn btn-link view-old-stats')
                            .attr('title', 'Voir les statistiques du commercial')
                            .attr('data-seller', item.node.id)
                            .append(
                                $('<i/>')
                                    .addClass('fa fa-chart-line')
                            );
                        btns.push($btnStats);

                        // Customers list
                        let urlRestaurants = self.settings.sellerRestaurantsBaseUrl.replace('__ID__', item.node.id);
                        let $btnCustomers = $('<a/>')
                            .attr('href', urlRestaurants)
                            .addClass('btn btn-link')
                            .attr('title', 'Voir les clients du commercial')
                            .append(
                                $('<i/>')
                                    .addClass('fa fa-address-book')
                            );
                        btns.push($btnCustomers);

                        let $btnModalDelete = $('<button/>')
                            .attr('type', 'button')
                            .addClass('btn btn-link text-danger')
                            .attr('title', 'Supprimer')
                            .append(
                                $('<i/>')
                                    .addClass('fas fa-trash')
                            )
                            .on('click', function (event) {
                                self.onClickDelete(item.node);
                            });
                        btns.push($btnModalDelete);

                        for (var i in btns) {
                            let $btn = btns[i];
                            $list.append(
                                $('<li/>')
                                    .addClass('list-inline-item')
                                    .append($btn)
                            );
                        }

                        return $list;
                    },
                },

            ]
        })
    }

    initializeOldStatsClick() {
        $('body').on('click', '.view-old-stats', function () {
            let $btn = $(this);
            let urlStats = window.App.get('oldAdminHomeUrl') + '/sellers/stats/simple&id=' + $btn.data('seller');
            let modal = new IFrame({
                'modalSize': 'full',
                'url': urlStats,
            });

            modal.show();

            return false;
        });
    }

    bindEvents() {
        this.$btnCreate.on('click', this.onClickCreate)
    }

    onClickCreate(event) {
        var self = this;
        event.preventDefault();
        event.stopPropagation();
        let modal = new CreateModal({
            'onSuccess': function (data) {
                let seller = data.seller;
                let url = self.settings.sellerShowBaseUrl.replace('__ID__', seller.id);
                window.redirect(url);
            }
        });
    }

    onClickDelete(seller) {
        var self = this;

        let $content = $('<div/>')
            .append(
                $('<div/>')
                    .append('Valider la suppression ?')
            );

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function (event, modal) {
                self.proceedDelete(seller, modal)
            },
            'onCancel': function (event, modal) {
            }
        })
        confirmModal.show();

    }

    proceedDelete(seller, confirmModal) {

        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'seller': {
                'value': seller.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteSeller",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function () {
            },
            'success': function (data) {
                confirmModal.hide();
                self.refresh();
            },
            'error': function (message, xhr) {
                confirmModal.hide();
                window.notify(message, "error");
            },
            'after': function () {
                //do nothing
            }
        });
        mutation.execute();
    }

}

module.exports = ListView;